module.exports = __webpack_public_path__ + "static/media/registerP.44491860.jpg";